(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gatsby-dla-firm-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  var s=document.getElementById('gdf-{{ section.id }}');
  if(!s)return;
  s.querySelectorAll('.gdf__service').forEach(function(c){
    c.addEventListener('mousemove',function(e){var r=c.getBoundingClientRect();c.style.setProperty('--glow-x',(e.clientX-r.left)+'px');c.style.setProperty('--glow-y',(e.clientY-r.top)+'px');});
    c.addEventListener('mouseleave',function(){c.style.setProperty('--glow-x','50%');c.style.setProperty('--glow-y','50%');});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gatsby-tematy-page"] && !Shopify.designMode) return;
  try {
    
(function(){var s=document.getElementById('gtp-{{ section.id }}');if(!s)return;s.querySelectorAll('.gtp__card').forEach(function(c){c.addEventListener('mousemove',function(e){var r=c.getBoundingClientRect();c.style.setProperty('--glow-x',(e.clientX-r.left)+'px');c.style.setProperty('--glow-y',(e.clientY-r.top)+'px');});c.addEventListener('mouseleave',function(){c.style.setProperty('--glow-x','50%');c.style.setProperty('--glow-y','50%');});});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gatsby-tematy"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.getElementById('gatsby-tematy-{{ section.id }}');
  if (!section) return;
  section.querySelectorAll('.gatsby-tematy__card').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      card.style.setProperty('--glow-x', (e.clientX - r.left) + 'px');
      card.style.setProperty('--glow-y', (e.clientY - r.top)  + 'px');
    });
    card.addEventListener('mouseleave', function () {
      card.style.setProperty('--glow-x', '50%');
      card.style.setProperty('--glow-y', '50%');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
